import ResourceManagement from "./ResourceManagement.presenter";

export default ResourceManagement;
